import keys from '@debbie/common/dist/cache/keys.js';
import { bodyMapper, deepFlattenToObject, } from '@debbie/common/dist/hooks/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { sortBy } from '@debbie/common/dist/util/index.js';
import * as webhooks from '@debbie/cortex/dist/api/hooks.js';
import { hookItemsEntity, useHook, useHookItem, } from '@debbie/cortex/dist/hooks/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import Errors from '../Errors.js';
import FormatJSON from '../FormatJSON.js';
import { Col, Row } from '../Grid/index.js';
import { Badge, Button, CopyToClipboard, Panel, PlaceholderLoader, Well, } from '../index.js';
import { useCreditorScope } from './creditorScope.js';
import HookCreditor from './HookCreditor.js';
const Webhook = (props) => {
    const { id } = useParams();
    const lang = useSelector((s) => s.lang);
    const { clientSite } = useCreditorScope();
    const hookItemLoadable = useHookItem(id);
    const hookItem = h.hasData(hookItemLoadable) ? hookItemLoadable.data : null;
    const hookItemError = h.isError(hookItemLoadable);
    const hookLoadable = useHook(hookItem?.hookId);
    const hook = h.hasData(hookLoadable) ? hookLoadable.data : null;
    const hookNotFound = h.isError(hookLoadable);
    const resendMutation = useMutation(async (hookItemId) => {
        await webhooks.executeHookItem(hookItemId);
        q.invalidate(keys.write.modify(hookItemsEntity, hookItemId));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.webhook);
        },
    });
    const bodyRaw = hookItem != null && hook != null
        ? {
            event: hookItem.event,
            time: new Date(hookItem.createdAt).toISOString(),
            data: handleBody(hook, hookItem),
        }
        : null;
    const body = bodyRaw != null && hook?.deepFlattenBody
        ? deepFlattenToObject(bodyRaw)
        : bodyRaw;
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "6" }, hook && hookItem ? (React.createElement(Panel, { header: lang.webhookSettings.webhook },
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, hookItem.event),
            !clientSite && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, lang.webhookSettings.columnCreditor),
                React.createElement(Well, null,
                    React.createElement(HookCreditor, { creditorId: hook.creditorId })))),
            hookItem.url && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, lang.webhookSettings.columnUrl),
                React.createElement(Well, null,
                    React.createElement("div", { style: { float: 'right', fontWeight: '900' } },
                        React.createElement(CopyToClipboard, { text: hookItem.url }, lang.webhookSettings.copy)),
                    hookItem.url))),
            React.createElement("h3", null, lang.webhookSettings.eventDate),
            React.createElement(Well, null, moment(hookItem.createdAt).format(THEME.DATE_FORMAT_LONG)),
            hook?.headers && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, lang.webhookSettings.headers),
                React.createElement(Well, null,
                    React.createElement("ul", null, Object.entries(hook.headers).map(([k, v]) => (React.createElement("li", { key: k },
                        k,
                        ":",
                        ' ',
                        k.toLocaleLowerCase() === 'authorization' ? '***' : v))))))),
            React.createElement("h3", null, lang.webhookSettings.body),
            React.createElement(Well, null,
                React.createElement("div", { style: { float: 'right', fontWeight: '900' } },
                    React.createElement(CopyToClipboard, { text: JSON.stringify(body) }, lang.webhookSettings.copy)),
                body && React.createElement(FormatJSON, { json: body })),
            hook?.bodyMappers && hook?.bodyMappers[hookItem.event] && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, lang.webhookSettings.bodyMapping),
                React.createElement(Well, null,
                    React.createElement(BodyMapping, { map: hook.bodyMappers[hookItem.event] })))))) : hookItemError || hookNotFound ? (React.createElement(Panel, { header: lang.webhookSettings.webhook },
            React.createElement(Errors, { errors: [
                    hookNotFound
                        ? lang.webhookSettings.hookNotFound
                        : lang.webhookSettings.failedToLoad,
                ] }))) : (React.createElement(PlaceholderLoader, null))),
        !hook?.pull && (React.createElement(Col, { width: "6" }, hook && hookItem ? (React.createElement(Panel, { header: React.createElement("span", null,
                React.createElement(Button, { loading: resendMutation.isLoading, onClick: () => resendMutation.mutate(hookItem.id), style: {
                        float: 'right',
                    }, size: "mini" }, lang.webhookSettings.resendWebhook),
                lang.webhookSettings.attempts) },
            hookItem.nextAttemptAt && (React.createElement("p", null,
                lang.webhookSettings.nextAttemptAt,
                ' ',
                moment(hookItem.nextAttemptAt).format(THEME.DATE_FORMAT_LONG))),
            sortBy(hookItem.attempts, (attempt) => new Date(attempt.createdAt).getTime(), { reverse: true }).map((attempt) => (React.createElement(Attempt, { key: attempt.id, attempt: attempt }))))) : hookItemError || hookNotFound ? (React.createElement(Panel, { header: lang.webhookSettings.attempts },
            React.createElement(Errors, { errors: [
                    hookNotFound
                        ? lang.webhookSettings.hookNotFound
                        : lang.webhookSettings.failedToLoad,
                ] }))) : (React.createElement(PlaceholderLoader, null))))));
};
const handleBody = (hook, item) => {
    if (hook.bodyMappers && hook.bodyMappers[item.event]) {
        const mapper = hook.bodyMappers[item.event];
        return bodyMapper(mapper, item.data);
    }
    else {
        return item.data;
    }
};
const Attempt = (props) => {
    const lang = useSelector((s) => s.lang);
    const { attempt } = props;
    const resultText = JSON.stringify(attempt.result);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement("p", null,
            React.createElement(Badge, { theme: attempt.successful ? THEME.SUCCESS : THEME.DANGEROUS }, attempt.successful
                ? lang.webhookSettings.attemptSuccess
                : lang.webhookSettings.attemptFailed),
            ' ',
            React.createElement("span", { style: { float: 'right' } }, moment(attempt.createdAt).format(THEME.DATE_FORMAT_LONG))),
        React.createElement(Well, { style: {
                backgroundColor: '#f4f4f4',
            } },
            React.createElement("div", { style: { float: 'right', fontWeight: '900' } },
                React.createElement(CopyToClipboard, { text: resultText }, lang.webhookSettings.copy)),
            resultText.slice(0, 500),
            ' ',
            resultText.length > 500 && (React.createElement("span", { style: { fontWeight: '900' } }, "[...]")))));
};
const BodyMapping = (props) => {
    return (React.createElement("ul", null, props.map.map((k, index) => {
        if (typeof k === 'string') {
            return React.createElement("li", { key: k }, k);
        }
        else {
            const entries = Object.entries(k);
            return entries.map(([key, value]) => {
                return (React.createElement("li", { key: `${index}-${key}` },
                    key,
                    React.createElement(BodyMapping, { map: value })));
            });
        }
    })));
};
export default Webhook;
//# sourceMappingURL=Webhook.js.map